import { UnreachableCaseError } from 'ts-essentials';
import {
  assertValidGeovectorRegionAndEnvironment,
  type GeovectorClientEnvironment,
  type GeovectorRegion,
} from '@trimble/utilities';
import { createClient, type Client } from '../generated/client';

export type { Client as MapsClient };

export type ServiceType = 'maps' | 'cloud';

export interface MapsClientOptions {
  env: GeovectorClientEnvironment;
  region: GeovectorRegion;
  service?: ServiceType;
}

const getMapsServiceBaseUrl = ({
  env,
  region,
  service = 'cloud',
}: MapsClientOptions): string => {
  assertValidGeovectorRegionAndEnvironment(env, region);

  const envSubdomain = env === 'prod' ? '' : `${env}.`;
  const cloudSubdomain =
    env === 'prod' ? 'api.trimble.com' : 'stage.api.trimblecloud.com';

  switch (service) {
    case 'cloud':
      return `https://cloud.${cloudSubdomain}/Map-Services/maps-${region}/1.0/`;

    case 'maps':
      return `https://${region}.${envSubdomain}api.maps.trimblegeospatial.com`;

    default:
      throw new UnreachableCaseError(service);
  }
};

export const createMapsServiceClient = ({
  env,
  region,
  service = 'cloud',
}: MapsClientOptions): Client => {
  const baseUrl = getMapsServiceBaseUrl({ env, region, service });

  return createClient({ baseUrl });
};
